export default __webpack_public_path__ + "static/media/raya.b76f4843.png";